import { DescriptionContainer } from '../DescriptionContainer';
import { GeoContainer } from '../GeoContainer';
import { LabelsListContainer } from '../LabelsListContainer';
import { PriceContainer } from '../PriceContainer';
import { RatingContainer } from '../RatingContainer';
import { TitleContainer } from '../TitleContainer';

export function GeneralInfoContainer() {
  return (
    <>
      <TitleContainer />
      <LabelsListContainer />
      <RatingContainer />
      <GeoContainer />
      <PriceContainer />
      <DescriptionContainer />
    </>
  );
}
